module.exports = __webpack_public_path__ + "img/slip.75e1719e.png";